import { BaseComponent } from './base.component';

export abstract class BasePageComponent extends BaseComponent {

}
